import { TextField } from "@mui/material";

const InputFormula = (props) => {
  return (
    <TextField
      {...props}
      onChange={props.onChange}
      disabled
      sx={{
        width: "100%",
        "& .MuiInputBase-root.MuiOutlinedInput-root": {
          backgroundColor: "#F6F8FC",
        },
      }}
      helperText={"Formula SUM"}
    />
  );
};

export default InputFormula;
